import type { Athlete } from '../model/models';

export default function findAthleteBySeed(array: Array<Athlete>, seed: number) {
  return array.find((element) => {
    return element.seed === seed;
  });
}
